import bet_mgm_logo            from "apps/BWW_PLAY_HUB/assets/img/bet_mgm.png";
import { EventCardBetMGMLogo } from "apps/BWW_PLAY_HUB/components/EventCard/EventCardBetMGMLogo";
import React                   from 'react';
import {IEvent} from 'modules/reducers/dashboard';
import moment from 'moment';
import {EventCardWrapper} from 'apps/BWW_PLAY_HUB/components/EventCard/EventCardWrapper';
import {EventCardPPHeader} from 'apps/BWW_PLAY_HUB/components/EventCard/EventCardPPHeader';
import {EventCardLogo} from 'apps/BWW_PLAY_HUB/components/EventCard/EventCardLogo';
import logo from 'apps/BWW_PLAY_HUB/assets/img/logos/ppLogo.svg';
import {EventTimer} from 'apps/BWW_PLAY_HUB/components/EventCard/EventTimer';
import {EventCardName} from 'apps/BWW_PLAY_HUB/components/EventCard/EventCardName';
import {EventDate} from 'apps/BWW_PLAY_HUB/components/EventCard/EventDate';
import styled from 'styled-components';
import playpff_bg from 'apps/BWW_PLAY_HUB/assets/img/cards/playoff_bg.png';
import nfl_bg from 'apps/BWW_PLAY_HUB/assets/img/cards/nfl_contest_bg.png';


const EventCardWrapperStyled = styled(EventCardWrapper)`
	${EventCardName} {
		color: #362E2C;
	}
	${EventDate} {
		color: #362E2C;
		margin-bottom: 40px;
	}
	.event-timer {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		margin-bottom: 0;
	}
`;

const EventCardPPHeaderWrapper = styled.div`
	position:relative;
`;

interface IProps {
	event: IEvent
}

const getBackgound = (event: IEvent) => {
	if ( event.is_playoff ) {
		return {
			background: playpff_bg,
			wrapperBackground: '#1C1C1C'
		}
	}

	if ( event.is_nfl ) {
		return {
			background: nfl_bg,
			wrapperBackground: '#1C1C1C'
		}
	}

	return {
		background: null,
		wrapperBackground: null
	}
}
export const EventCardUpcomingPP: React.FC<IProps> = ({event}) => {
	const start = moment(event.start)
		.format('hh:mma, ddd, MMM DD YYYY');

	const {background, wrapperBackground} = getBackgound(event);

	return (
		<EventCardWrapperStyled>
			<EventCardPPHeaderWrapper>
				<EventCardPPHeader isSmall={true} image={background}>
					<EventCardLogo src={logo} alt={'PicksAndProps'}/>
					<EventCardBetMGMLogo src={bet_mgm_logo} alt={'BetMGMLogo'}/>
				</EventCardPPHeader>
				<EventTimer
					className={'event-timer'}
					date={event.start}
					uniq={event.id}
					wrapperBackground={wrapperBackground}
				/>
			</EventCardPPHeaderWrapper>

			<EventCardName>
				{ event.name }
			</EventCardName>
			<EventDate>{ start }</EventDate>

		</EventCardWrapperStyled>
	)
};
